// Mixin comum aos painéis de envolvido: props padronizadas + filtro de data.
export default {
  filters: {
    formatDate(val) {
      if (!val) return '—'
      const d = new Date(val)
      return d.toLocaleString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    },
  },
  props: {
    // Ocorrência atual.
    occurrenceId: { type: [Number, String], required: true },
    // Id do mestre (pessoa/veículo/...) — usado nas escritas clínicas.
    involvedId: { type: [Number, String], default: null },
    // Id da participação (occurrence_involveds.id) — usado no desfecho.
    occurrenceInvolvedId: { type: [Number, String], default: null },
    // Disciplina da ocorrência (filtra catálogos como desfechos).
    disciplineId: { type: [Number, String], default: null },
  },
}
